import Layout from "@xtribe/shared/components/lib/Layout/Layout";
import ForgotPasswordForm from "@xtribe/shared/components/Auth/ForgotPasswordForm";
import NextHead from "@xtribe/shared/components/lib/Head/NextHead";
import Navbar from "@xtribe/shared/components/lib/Navbar/Navbar";
import { GetServerSideProps } from "next";
import { getRequestSlug } from "@xtribe/shared/lib/host";
import { getPublicTeamData } from "./api/v0/teams/public";
import { Team } from "@prisma/client";
import Avatar from "@xtribe/shared/components/lib/Avatar";
import { AuthPageProps } from "./signin";
import { serializeQuery } from "@xtribe/shared/lib/text-transformations";

const ForgotPassword: React.FC<AuthPageProps> = ({ team, queryString }) => {
  return (
    <div className="theme-admin">
      <NextHead
        title={"Passwort vergessen — xTribe"}
        description={"Hier kannst du dein Passwort zurücksetzen"}
      />
      <Layout>
        <div
          className={`px-2 md:px-4 min-h-screen flex py-8 md:py-16 items-center`}
        >
          <ForgotPasswordForm team={team} queryString={queryString} />
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  let requestHost;
  const host = ctx.req.headers.host;
  if (
    process.env.NEXT_PUBLIC_APP_URL!?.includes(host ?? "") ||
    process.env.NEXT_PUBLIC_AUTH_URL!?.includes(host ?? "")
  ) {
    requestHost = ctx.query.request_host;
  } else {
    requestHost = host;
  }
  let slug;
  let customDomain;
  if (
    requestHost?.includes(process.env.NEXT_PUBLIC_APP_HOST!) ||
    requestHost?.includes("ghoststudio.io")
  ) {
    slug = getRequestSlug(requestHost.toString());
  } else {
    customDomain = requestHost?.toString();
  }
  let team = null;
  if (slug || customDomain) {
    team = await getPublicTeamData({ slug, customDomain, isSignup: true });
  }
  const queryString = serializeQuery(ctx.query);
  return { props: { team, queryString } };
};
export default ForgotPassword;
